import React from 'react';

/**
 * Mobile-friendly numeric PIN keypad.
 * Parent owns the value and the password-manager <input>.
 */
export default function PinKeypad({ value, onChange, maxLength = 10, disabled = false }) {
  const AppendDigit = (digit) => {
    if (disabled || value.length >= maxLength) return;
    onChange(value + digit);
  };

  const Backspace = () => {
    if (disabled || !value.length) return;
    onChange(value.slice(0, -1));
  };

  const Clear = () => {
    if (disabled) return;
    onChange('');
  };

  const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'clear', '0', 'back'];

  return (
    <div className="pin-keypad">
      <div className="pin-grid" role="group" aria-label="PIN keypad">
        {keys.map((key) => {
          if (key === 'clear') {
            return (
              <button
                key={key}
                type="button"
                className="pin-key pin-key-action"
                onClick={Clear}
                disabled={disabled || value.length === 0}
                aria-label="Clear PIN"
              >
                Clear
              </button>
            );
          }
          if (key === 'back') {
            return (
              <button
                key={key}
                type="button"
                className="pin-key pin-key-action"
                onClick={Backspace}
                disabled={disabled || value.length === 0}
                aria-label="Delete last digit"
              >
                ⌫
              </button>
            );
          }
          return (
            <button
              key={key}
              type="button"
              className="pin-key"
              onClick={() => AppendDigit(key)}
              disabled={disabled || value.length >= maxLength}
            >
              {key}
            </button>
          );
        })}
      </div>
    </div>
  );
}
